import { normalizePathname } from '@zapier/url-utils';
export const isLinkSelected = (linkHref, currentPageHref) => {
    if (currentPageHref.startsWith('/')) {
        return normalizePathname(linkHref).endsWith(normalizePathname(currentPageHref));
    }
    let parsedSelectedHref;
    try {
        parsedSelectedHref = new URL(currentPageHref);
    }
    catch (_a) {
        return normalizePathname(linkHref).endsWith(normalizePathname(currentPageHref));
    }
    const hostname = parsedSelectedHref.hostname;
    if (hostname === 'zapier.com' || hostname === 'zapier-staging.com') {
        return normalizePathname(linkHref).endsWith(normalizePathname(parsedSelectedHref.pathname));
    }
    if (hostname.split('.').length > 2) {
        return linkHref.includes(hostname);
    }
    return normalizePathname(linkHref).endsWith(normalizePathname(currentPageHref));
};
//# sourceMappingURL=utils.js.map
// @zapier/universal-layout@8.6.23 (c29ded5a6)
